import React from 'react';
import {Link} from "react-router-dom";

import Delete from 'Components/Partials/Modals/Delete';
import {IndexTable} from 'Components/Utilities';
import AdminRunReportModal from 'Components/Partials/Modals/AdminRunReportModal';
import {SecondaryButton} from 'Components/Button';

import AdminLayout from 'Pages/Admin/AdminLayout';

import AdminScheduledReportsApi from 'Services/Api/Admin/ScheduledReports';
import AdminScheduledReportReportsApi from 'Services/Api/Admin/ScheduledReportReports';

export default class Index extends React.Component {
    /**
     * @var columns
     * @type {array}
     */
    columns = [
        {
            label: 'Title',
            value: 'title',
            type: 'string',
            orderable: 'Title'
        },
        {
            label: 'Report Type',
            value: (record) => record.type.replace(/([A-Z])/g, ' $1').trim(),
            type: 'callback',
            orderable: null,
        },
        {
            label: 'Params',
            value: (record) => record.readable_params && Object.entries(record.readable_params).map((object, key) => (
                <p key={key}>
                    {object[0]}: {object[1]}
                </p>
            )),
            type: 'callback',
            orderable: null,
        },
    ];

    /**
     * @var state
     * @type {{scheduled_report_id: string}}
     */
    state = {
        scheduled_report_id: this.props.match?.params?.scheduledReport ?? '',
        scheduled_report: null
    };

    /**
     * @method componentDidMount
     */
    componentDidMount() {        
        if (this.state.scheduled_report_id) {
            this.loadData();
        }
    }

    /**
     * @method loadData
     */
    loadData = async () => {
        const {scheduled_report_id} = this.state;

        const response = await AdminScheduledReportsApi.get(scheduled_report_id);

        this.setState({
            scheduled_report: response.data.data
        });
    }
    
    /**
     * @method getRowActions
     * @param {object} item
     */
    getRowActions = (item) => {
        return [
            {
                type: "modalTrigger",
                component: Delete,
                props: {
                    itemName: 'report',
                    itemId: item.id,
                    onDeleteApi: AdminScheduledReportReportsApi.delete
                },
                text: 'Delete'
            }
        ];
    }

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const {scheduled_report_id, scheduled_report} = this.state;

        return (
            <AdminLayout title={`Scheduled Report Builder - ${scheduled_report?.title}`}>
                <div className="flex justify-center mb-4">
                    <Link to="/admin/scheduled-reports">
                        <SecondaryButton type="button" text="Back" />
                    </Link>
                </div>

                <IndexTable
                    columns={this.columns}
                    displaySearchBar={false}
                    storeModal={{
                        component: AdminRunReportModal,
                        props: {
                            scheduled_report_id
                        }
                    }}
                    loadDataCallback={(data) => AdminScheduledReportReportsApi.get(null, {
                        ...data,
                        scheduled_report_id
                    })}
                    rowActions={this.getRowActions}
                    actionsJustify="center"
                    eventApi={AdminScheduledReportReportsApi}
                    itemName="reports"
                />
            </AdminLayout>
        )
    }
}
